import { render } from "./LanguageList.vue?vue&type=template&id=5045d157&scoped=true"
import script from "./LanguageList.vue?vue&type=script&lang=js"
export * from "./LanguageList.vue?vue&type=script&lang=js"

import "./LanguageList.vue?vue&type=style&index=0&id=5045d157&lang=scss&scoped=true"

import exportComponent from "/home/avangard/git/toode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5045d157"]])

export default __exports__